import type { ComponentType } from 'react'
import { ErrorBoundary } from '@/components/Feedback'

export function withErrorBoundary<Props extends object>(Component: ComponentType<Props>) {
  return function WrappedComponent(props: Props) {
    return (
      <ErrorBoundary>
        <Component {...props} />
      </ErrorBoundary>
    )
  }
}
